import script from "./PurchaseBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchaseBanner.vue?vue&type=script&setup=true&lang=js"

import "./PurchaseBanner.vue?vue&type=style&index=0&id=3d844bc3&scoped=true&lang=scss"
import "./PurchaseBanner.vue?vue&type=style&index=1&id=3d844bc3&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d844bc3"]])

export default __exports__